import { render, staticRenderFns } from "./yesBadge.vue?vue&type=template&id=46762871"
import script from "./yesBadge.vue?vue&type=script&lang=js"
export * from "./yesBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports